import React, { forwardRef, useImperativeHandle, useRef, useState } from 'react';
import NavigateRightUp from '@uber/base-icons/navigate-right-up';
import { type Theme, useStyletron } from 'baseui';
import { ParagraphSmall } from 'baseui/typography';
export type StageDragHelperTextRefT = {
  show: () => void;
};
const containerStyle = (theme: Theme) => ({
  position: 'absolute',
  top: theme.sizing.scale700,
  left: '50%',
  transform: 'translateX(-50%)',
  backgroundColor: theme.colors.backgroundInverseSecondary,
  pointerEvents: 'none',
  borderRadius: theme.borders.radius300,
  paddingLeft: theme.sizing.scale500,
  paddingRight: theme.sizing.scale500,
  textAlign: 'center'
} as const);
const HELPER_TOAST_TIMEOUT_DURATION = 3000; // 3 seconds

const _StageDragHelperText = forwardRef<StageDragHelperTextRefT>((_, ref) => {
  const [css, theme] = useStyletron();
  const [isVisible, setIsVisible] = useState(false);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  useImperativeHandle(ref, () => ({
    show: () => {
      if (!isVisible) {
        setIsVisible(true);
      }
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
      timerRef.current = setTimeout(() => {
        setIsVisible(false);
        timerRef.current = null;
      }, HELPER_TOAST_TIMEOUT_DURATION);
    }
  }), [isVisible]);
  if (!isVisible) {
    return null;
  }
  return <div className={css(containerStyle(theme))}>
      <ParagraphSmall color={theme.colors.contentInverseSecondary}>
        Hold Alt/Option (⌥) to move the stage, or use the Pointer tool (
        <NavigateRightUp className={css({
        verticalAlign: 'middle'
      })} />) to deselect.
      </ParagraphSmall>
    </div>;
});
_StageDragHelperText.displayName = 'StageDragHelperText';
export const StageDragHelperText = React.memo(_StageDragHelperText);